// extracted by mini-css-extract-plugin
module.exports = {"formControl":"VideoTypeSelect_formControl__2wt1l"};